// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Wrapper_pageWrapper__aUlG1","overlayWrapper":"Wrapper_overlayWrapper__taTXd"};